<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>{{ json_data.save_type == 'create' ? $t('menu.OTPlanCreate') : $t('menu.OTPlanEdit') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout
              row
              wrap
              pa-4
              style="background-color:#fff; margin-top:5px; border-radius:5px;"
            >
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        v-if="json_data.save_type == 'create'"
                        :label="$t('doc_no')"
                        append-icon="fas fa-plus-circle"
                        hide-details
                        :readonly="json_data.save_type == 'create'"
                        v-model="form_model.doc_no"
                        :rules="form_rules.doc_no"
                        required
                        @click:append="doNewGuid"
                      />

                      <v-text-field
                        v-if="json_data.save_type == 'update'"
                        :label="$t('doc_no')"
                        hide-details
                        readonly
                        v-model="form_model.doc_no"
                        :rules="form_rules.doc_no"
                        required
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-autocomplete
                        hide-details
                        :loading="loading"
                        v-model="form_model.emp_code"
                        :items="Employee_List"
                        item-text="name"
                        item-value="code"
                        :label="$t('employee_code')"
                        allow-overflow
                        append-icon="search"
                        clearable
                        required
                        :rules="form_rules.emp_code"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('begin_datetime')"
                        hide-details
                        v-model="begin_date"
                        :rules="form_rules.begin_date"
                        required
                        type="datetime-local"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('end_datetime')"
                        hide-details
                        v-model="end_date"
                        :rules="form_rules.end_date"
                        required
                        type="datetime-local"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('amount_OT')"
                        v-model="form_model.ot_hour"
                        hide-details
                        type="number"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('Breaktime')"
                        v-model="form_model.break_hour"
                        hide-details
                        type="number"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-select
                        :items="ottype"
                        :label="$t('ot_type')"
                        item-text="name"
                        item-value="value"
                        hide-details
                        v-model="form_model.ot_type"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import Utils from "@/utils/";
import DocumentService from "@/services/DocumentService";

export default {
  props: {
    json_data: Object
  },
  watch: {
    json_data(val) {
      this.doNewGuid();
      if (val.data != null) {
        this.form_model = val.data;
        console.log(this.form_model);
        this.form_model.ot_type = val.data.ot_type.toString();
        let begindate_split = this.form_model.begin_datetime.split(":");
        let enddate_split = this.form_model.end_datetime.split(":");
        let begindate = begindate_split[0] + ":" + begindate_split[1];
        let enddate = enddate_split[0] + ":" + enddate_split[1];
        this.begin_date = begindate.replace(" ", "T");
              this.end_date = enddate.replace(" ", "T");
         console.log(this.begin_date);

      } else {
        this.$refs.form.resetValidation();
      }
    }
  },
  data: () => ({
    form_valid: false,
    begin_date: "",
    end_date: "",
    ottype: [
      {
        value: "0",
        name: "ชั่วโมง"
      },
      {
        value: "1",
        name: "เต็มวัน"
      }
    ],
    form_model: {
      emp_code: "",
      begin_datetime: "",
      end_datetime: "",
      ot_type: "0",
      doc_no: "",
      ot_hour: 0,
      break_hour: 0,
      creator_code: localStorage._usercode
    },
    form_rules: {
      emp_code: [v => !!v || "do not empty."],
      doc_no: [v => !!v || "do not empty."],
      begin_date: [v => !!v || "do not empty."],
      end_date: [v => !!v || "do not empty."]
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    }
  }),
  created: function() {
    this.getEmployee("newData");
    this.doNewGuid();
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"])
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    doNewGuid() {
      this.form_model.doc_no = Utils.newGuid("B");
    },
    clearForm() {
      (this.form_model = {
        emp_code: "",
        begin_datetime: "",
        end_datetime: "",
        ot_type: "0",
        doc_no: "",
        ot_hour: 0,
        break_hour: 0,
        creator_code: localStorage._usercode
      }),
        (this.begin_date = ""),
        (this.end_date = "");
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    // getDetail(param) {
    //   DocumentService.getOtPlanByCode(param)
    //     .then(res => {
    //       this.showLoading = false;
    //       this.form_model = res.data;
    //       this.form_model.ot_type = this.form_model.ot_type.toString();
    //       let begindate_split = this.form_model.begin_datetime.split(":");
    //       let enddate_split = this.form_model.end_datetime.split(":");
    //       let begindate = begindate_split[0] + ":" + begindate_split[1];
    //       let enddate = enddate_split[0] + ":" + enddate_split[1];
    //     if (this.form_model.is_day == "0") {
    //           this.begin_date = begindate.replace(" ", "T");
    //           this.end_date = enddate.replace(" ", "T");
    //         } else {
    //           this.begin_date = begindate.split(" ")[0];
    //           this.end_date = enddate.split(" ")[0];
    //         }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    //},
    onSave() {
      if (this.form_valid) {
        this.form_model.begin_datetime =
          this.begin_date.replace("T", " ") + ":00.0";
        this.form_model.end_datetime =
          this.end_date.replace("T", " ") + ":00.0";
        DocumentService.createOtplan(this.form_model)
          .then(res => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch(err => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
    onUpdate() {
      if (this.form_valid) {
        this.form_model.begin_datetime =
          this.begin_date.replace("T", " ") + ":00.0";
        this.form_model.end_datetime =
          this.end_date.replace("T", " ") + ":00.0";
        DocumentService.updateOtplan(this.form_model)
          .then(res => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch(err => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    }
  }
};
</script>
<style>
.v-card__text {
  padding: 0px !important;
}
</style>